import React, { useMemo } from 'react';

interface IProps {
    urlWebp?: string,
    children: React.ReactElement<HTMLImageElement>,
}

const WebpImage = ({ urlWebp, children }: IProps): JSX.Element => {
    const isSvg = useMemo(() => {
        const image = children?.props?.src;
        if (image) {
            const extension = image.split('.').pop();

            return extension === 'svg';
        }
        return false;
    }, [children]);

    return (urlWebp && !isSvg)
        ? <picture draggable={false}>
            <source srcSet={urlWebp} type='image/webp' />
            {children}
        </picture>
        : <>{children}</>;
};

export default WebpImage;
